/**
 * File: QueryProvider.tsx
 * Path: apps/admin/src/modules/app/components/QueryProvider.tsx
 * Description: Initializes TanStack Query client and provides the cache context to the application.
 */

import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useQueryProviderController } from '@/modules/app/hooks/useQueryProviderController';

interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * Global React Query configuration.
 * Retries are disabled by default for cleaner development; cache times
 * are in queryClient.ts.
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  const { queryClient } = useQueryProviderController();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};